import React from 'react';
import { IHelpArticle, MarkdownHelpArticles } from './help-articles';
import { PRIVATE_MARKDOWN_HELP_VIEWER_PILL } from './pill';
import { mergeStyles } from '@fluentui/react';

interface IPRIVATE_MARKDOWN_HELP_VIEWER_PILLBOXProps {
  activeArticle: IHelpArticle;
  onArticleChangeRequest: (article: IHelpArticle) => void;
}

const getStyleClass = () => {
  const pillSize = 16;

  return mergeStyles([{
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: pillSize * 1.5,
  }]);
}

export const PRIVATE_MARKDOWN_HELP_VIEWER_PILLBOX: React.FunctionComponent<IPRIVATE_MARKDOWN_HELP_VIEWER_PILLBOXProps> = (props) => {
  const mainStyle = getStyleClass();

  return (
    <div className={mainStyle}>
      {MarkdownHelpArticles.map(article =>
      <PRIVATE_MARKDOWN_HELP_VIEWER_PILL
        key={article.articleId}
        article={article}
        isActive={article.articleId === props.activeArticle.articleId}
        onPillSelected={props.onArticleChangeRequest}
      />)}
    </div>
  );
};
